// Helpers for the admin availability calendar. All times are unix seconds; the
// UI displays them in Europe/Bratislava implicitly (the same zone Dajana lives
// in). We don't bother with TZ-aware libraries — these helpers operate in the
// browser's local TZ which, for the admin user, will always be CET/CEST.

export function startOfWeekMonday(date: Date): Date {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  // JS Sunday=0; we want Monday=0
  const day = (d.getDay() + 6) % 7;
  d.setDate(d.getDate() - day);
  return d;
}

export function addDays(date: Date, days: number): Date {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
}

export function unixSecondsAt(date: Date, hour: number, minute: number): number {
  const d = new Date(date);
  d.setHours(hour, minute, 0, 0);
  return Math.floor(d.getTime() / 1000);
}

export function fromUnixSeconds(s: number): Date {
  return new Date(s * 1000);
}

const SK_DAY_NAMES = ['Po', 'Ut', 'St', 'Št', 'Pi', 'So', 'Ne'];
export function shortDayName(date: Date): string {
  // JS Sunday=0 → index 6, Monday=1 → index 0.
  return SK_DAY_NAMES[(date.getDay() + 6) % 7] ?? '';
}

export function formatHHMM(date: Date): string {
  return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
}

export function formatDayLabel(date: Date): string {
  return `${date.getDate()}.${date.getMonth() + 1}.`;
}
